var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ChapterAccordion } from './ChapterAccordion';
import { Lessons } from './Lessons';
var Chapters = function (_a) {
    var assignedLessons = _a.assignedLessons, chapters = _a.chapters, onChapterAssign = _a.onChapterAssign, onChapterDelete = _a.onChapterDelete, onLessonAssign = _a.onLessonAssign, onLessonDelete = _a.onLessonDelete;
    return (_jsx(_Fragment, { children: chapters.map(function (_a) {
            var name = _a.name, lessons = _a.lessons, chapterId = _a.id;
            var checkedLessons = lessons.filter(function (l) {
                return assignedLessons.includes(l.id);
            }).length;
            var isChapterChecked = checkedLessons > 0;
            var isChapterIndeterminate = checkedLessons < lessons.length && assignedLessons.length > 0;
            return (_jsx(ChapterAccordion, __assign({ text: name, checked: isChapterChecked, indeterminate: isChapterIndeterminate, id: chapterId, onAssign: onChapterAssign, onDelete: onChapterDelete }, { children: _jsx(Lessons, { lessons: lessons, assignedLessons: assignedLessons, onAssign: onLessonAssign, onDelete: onLessonDelete }, chapterId + "_" + assignedLessons.length) }), chapterId));
        }) }, void 0));
};
export { Chapters };
